import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const DESIGN_WIDTH = 1900;
const DESIGN_HEIGHT = 1180; 

const AUTH_PATHS = ["/login", "/esqueciasenha", "/redefinir_senha.php", "/redefinir_senha"];

export default function LetterboxWrapper({ children }) {
  const [scale, setScale] = useState(1);
  const location = useLocation();

  const isAuthPage = AUTH_PATHS.some((p) => location.pathname === p || location.pathname.startsWith("/redefinir_senha/"));
  const bgColor = isAuthPage ? "#362191" : "#fff";

  useEffect(() => {
    const update = () => {
      const scaleX = window.innerWidth / DESIGN_WIDTH;
      const scaleY = window.innerHeight / DESIGN_HEIGHT;
      setScale(Math.min(scaleX, scaleY));
    };
    update();
    window.addEventListener("resize", update);
    // also listen for orientation changes on tablets
    window.addEventListener("orientationchange", () => {
      setTimeout(update, 100); // small delay — iOS fires this before dimensions update
    });
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, []);

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: bgColor,
      }}
    >
      <div
        style={{
          width: DESIGN_WIDTH,
          height: DESIGN_HEIGHT,
          transform: `scale(${scale})`,
          transformOrigin: "top left",
        }}
      >
        {children}
      </div>
    </div>
  );
}